// extracted by mini-css-extract-plugin
export default {"button":"darkBorderedBtn_button__5FEpo"};